module.exports = __webpack_public_path__ + "static/r2-a967d29f823014ee9bc0cbb064f9c292.png";